var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.6,2.3c-3.7-0.1-11,0-14.6,0.1c-133.8,2.9-240.5,116-240.1,250.9l0.2,73l102.7-0.4l-0.2-73 c-0.3-80.4,64.8-147.1,145-147.3c80.2-0.3,145.7,66,146,146.3l0.2,73l102.7-0.4l-0.2-73C644.9,116.6,537.4,4.2,403.6,2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M663.8,323.1h-15.6H545.5h0H407.3h-14.6H254.5H151.8h-15.6c-24,0-43.6,24.8-43.6,55.4v365.9c0,30.6,19.6,55.6,43.6,55.6 h527.6c24,0,43.6-25,43.6-55.6V378.5C707.4,347.9,687.8,323.1,663.8,323.1z M449.4,561.1v110.6c0,12.7-10.6,23.4-23.3,23.4h-52.3 c-12.7,0-23.3-10.7-23.3-23.4V561.1c-12.3-12.1-19.4-28.8-19.4-47.3c0-35.1,27.1-65.2,61.6-66.6c3.7-0.1,11-0.1,14.6,0 c34.5,1.4,61.6,31.5,61.6,66.6C468.9,532.2,461.7,549,449.4,561.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.800b85445b69399ddc47fd14c251733f.svg";
export { ForwardRef as ReactComponent };